import { getWithAuth, putWithAuth } from './http.service';
import {
    GET_BROKER_SELF_PRICE_NOTIFICATIONS_URL,
    DISMISS_BROKER_SELF_PRICE_NOTIFICATION_URL
} from './url.service';

// Every ACTIVE Broker Price Hit notification for the calling IDB broker. Response
// entities are already the BrokerPriceHitDialog `hits` shape (server-shaped).
export const getBrokerSelfPriceNotifications = () => getWithAuth(GET_BROKER_SELF_PRICE_NOTIFICATIONS_URL());

// Dismiss one notification (marks it CLOSED server-side).
export const dismissBrokerSelfPriceNotification = (id) => putWithAuth(DISMISS_BROKER_SELF_PRICE_NOTIFICATION_URL(id), {});
